import React from "react";

const PaymentPage = () => (
  <main className="container py-5">
    <h5>Plans are purchased in the app</h5>
    <p>
      Monthly and yearly plans are bought through the App Store or Google Play.
    </p>
  </main>
);

export default PaymentPage;
